import React, { useEffect } from "react";
import DistributorConnectionTile from "./DistributorConnectionTile";
import {
  GridContainer,
  useToast,
} from "@swordsweeper/ssi-ui-component-library";
import SpinningLoader from "@src/components/common/SpinningLoader/SpinningLoader";
import { DistributorConnectionStatus } from "./DistributorConnectionConstants";
import { Distributor } from "@src/constants/Distributors";
import { useCurrentUserStore } from "@src/state/currentUserState";

export default function AccountDistributorSettings() {
  const { showToast } = useToast();
  const {
    distributorConnections,
    loadingDistributorConnections,
    fetchDistributorConnections,
    updateDistributorConnectionStatus,
    updateDistributorPreferredStatus,
  } = useCurrentUserStore();

  useEffect(() => {
    // Always fetch with OAuth link on the distributor settings page since users
    // may click "Connect to Covetrus" - we need fresh OAuth state for that flow
    if (!loadingDistributorConnections) {
      fetchDistributorConnections({ includeOAuthLink: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleUpdateDistributorConnectionStatus = async (
    distributor: Distributor,
    status: DistributorConnectionStatus,
  ) => {
    updateDistributorConnectionStatus(distributor, status);
    // Refresh connections from server to ensure we have latest data
    await fetchDistributorConnections({ includeOAuthLink: true });
  };

  const handleUpdatePreferredStatus = async (
    distributor: Distributor,
    isPreferred: boolean,
  ) => {
    updateDistributorPreferredStatus(distributor, isPreferred);
    // Refresh connections from server to ensure we have latest data
    await fetchDistributorConnections({ includeOAuthLink: true });
  };

  return (
    <div className="margin-top-md">
      {loadingDistributorConnections && <SpinningLoader />}
      {!!distributorConnections && (
        <GridContainer gap="var(--margin-lg)" columns={{ base: 2 }}>
          {distributorConnections.map((distributorConnection) => (
            <React.Fragment
              key={`account-distributor-connection-tile-${distributorConnection.distributor}`}
            >
              <DistributorConnectionTile
                {...distributorConnection}
                onUpdateDistributorConnectionStatus={(status) =>
                  handleUpdateDistributorConnectionStatus(
                    distributorConnection.distributor,
                    status,
                  )
                }
                onUpdatePreferredStatus={(isPreferred) =>
                  handleUpdatePreferredStatus(
                    distributorConnection.distributor,
                    isPreferred,
                  )
                }
              />
            </React.Fragment>
          ))}
        </GridContainer>
      )}
    </div>
  );
}
